module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-field-widget"
  }, [_c('div', {
    staticClass: "filter-field-widget-header"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterSelectedValue),
      expression: "filterSelectedValue"
    }],
    staticClass: "colorpicker-filter-field-alt",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterSelectedValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.hookedFilterValues), function(filterValue) {
    return _c('option', {
      domProps: {
        "value": filterValue.value,
        "textContent": _vm._s(filterValue.label)
      }
    })
  })), _c('a', {
    staticClass: "compare-fabrics-link doc-link scrollAnchor",
    attrs: {
      "href": "#compare_fabrics_tamisant",
      "target": _vm._blank
    },
    domProps: {
      "textContent": _vm._s(_vm.frText.abTest.prd14.variationB.fields.colorFilter.compareMaterialLink)
    }
  })]), _c('div', {
    staticClass: "filter-field-widget-tags"
  }, _vm._l((_vm.taggedFilters), function(taggedFilter) {
    return _c('div', {
      staticClass: "filter-field-widget-tag",
      domProps: {
        "textContent": _vm._s(taggedFilter.label)
      },
      on: {
        "click": function($event) {
          _vm.removeTag(taggedFilter.value)
        }
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-297fbefd!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@oliverstore/core-rendering-engine/src/views/rendering_unit/abTest/FilterFieldWidget.vue
// module id = 340
// module chunks = 1